import React from "react";
import { Link } from "react-router-dom";

function InkAndEcho() {

  return (

    <main className="homepage articles-page public-section-landing">

      <h1 style={{ textAlign: "center" }}>
        Ink &amp; Echo
      </h1>

      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: "40px",
          fontSize: "18px"
        }}
      >
        Browse Ink &amp; Echo by category.
      </p>

      <div className="article-category-grid">

        <Link
          to="/articles/ink-and-echo/stories"
          className="publication-card"
        >
          <div
            className="landing-category-icon"
            aria-hidden="true"
          >
            📖
          </div>

          <h2>Stories</h2>

          <p>
            Short stories, fiction and narrative writing.
          </p>
        </Link>

        <Link
          to="/articles/ink-and-echo/poems"
          className="publication-card"
        >
          <div
            className="landing-category-icon"
            aria-hidden="true"
          >
            🪶
          </div>

          <h2>Poems</h2>

          <p>
            Poetry, verse and creative expression.
          </p>
        </Link>

        <Link
          to="/articles/ink-and-echo/articles"
          className="publication-card"
        >
          <div
            className="landing-category-icon"
            aria-hidden="true"
          >
            ✒️
          </div>

          <h2>Articles</h2>

          <p>
            Literary, cultural and reflective articles.
          </p>
        </Link>

      </div>

    </main>

  );

}

export default InkAndEcho;